import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import DashboardLayout from "./components/DashboardLayout";
import LoginPage from "./pages/LoginPage";
import StocksInPlayPage from "./pages/StocksInPlayPage";
import CheckStockPage from "./pages/CheckStockPage";
import WatchlistPage from "./pages/WatchlistPage";
import MarketDetailsPage from "./pages/MarketDetailsPage";
import MarketConditionsPage from "./pages/MarketConditionsPage";
import HistoryPage from "./pages/HistoryPage";
import HistoryYearPage from "./pages/HistoryYearPage";
import OurOfferPage from "./pages/OurOfferPage";
import ManualPage from "./pages/ManualPage";
import AdminPage from "./pages/AdminPage";
import AdminRoute from "./components/AdminRoute";
import PlaceholderPage from "./pages/PlaceholderPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<Navigate to="/stocks-in-play" replace />} />
            <Route path="/stocks-in-play" element={<StocksInPlayPage />} />
            <Route
              path="/watchlist"
              element={<WatchlistPage />}
            />
            <Route
              path="/market-conditions"
              element={<MarketConditionsPage />}
            />
            <Route
              path="/check-stock"
              element={<CheckStockPage />}
            />
            <Route
              path="/market-details"
              element={<MarketDetailsPage />}
            />
            <Route path="/history" element={<HistoryPage />} />
            <Route path="/history/:yearId" element={<HistoryYearPage />} />
            <Route path="/our-offer" element={<OurOfferPage />} />
            <Route path="/manual" element={<ManualPage />} />
            <Route
              path="/admin"
              element={
                <AdminRoute>
                  <AdminPage />
                </AdminRoute>
              }
            />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
